import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { CreateSymptomRow, SymptomRow, UpdateSymptomRow } from "./symptom.type";

export const getSymptom = async (symptomId: string): Promise<SymptomRow> => {
  const slug = ApiEndpoints.symptom + `/${symptomId}`;

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<SymptomRow>(slug, options);
};

export const getSymptoms = async (userId?: string): Promise<SymptomRow[]> => {
  const slug = ApiEndpoints.symptom + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<SymptomRow[]>(slug, options);
};

export const updateSymptom = async (
  symptom: UpdateSymptomRow,
  patientUserId?: string
): Promise<SymptomRow> => {
  let slug = ApiEndpoints.symptom + "/" + symptom.id;

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "PUT", body: symptom });

  return fetchData<SymptomRow>(slug, options);
};

export const createSymptom = async (
  symptom: CreateSymptomRow,
  patientUserId?: string
): Promise<SymptomRow> => {
  let slug = ApiEndpoints.symptom + "/";

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "POST", body: symptom });

  return fetchData<SymptomRow>(slug, options);
};
